export const ANALYTICS_DESTINATIONS = [
  { section: "overview", label: "Monthly report", group: "Reports", permissions: ["/admin/analytics"] },
  { section: "growth", label: "Revenue & customers", group: "Reports", permissions: ["/admin/analytics", "/admin/analytics/customers"] },
  { section: "sales", label: "Sales", group: "Reports", permissions: ["/admin/analytics/sales"] },
  { section: "operations", label: "Operations", group: "Reports", permissions: ["/admin/analytics/operations"] },
  { section: "demand", label: "Leads & conversion", group: "Acquisition", permissions: ["/admin/analytics/demand"] },
  { section: "partner-sites", label: "Partner sites", group: "Acquisition", permissions: ["/admin/analytics/demand"] },
  { section: "ads", label: "Advertising", group: "Acquisition", permissions: ["/admin/ads"] },
] as const;

export type AnalyticsDestinationSection = (typeof ANALYTICS_DESTINATIONS)[number]["section"];

const VIEW_ALIASES = new Map<string, AnalyticsDestinationSection>([
  ["revenue", "growth"], ["customers", "growth"],
  ["acquisition", "demand"], ["leads", "demand"], ["quotes", "demand"], ["tracking", "demand"],
  ["google-ads", "ads"], ["meta-ads", "ads"], ["funnel", "ads"], ["sources", "ads"],
  ["products", "operations"], ["shipping", "operations"], ["cash-conversion", "operations"],
]);

export function analyticsDestinationSection(view: string | null): AnalyticsDestinationSection {
  if (view === null) return "overview";
  return ANALYTICS_DESTINATIONS.find((entry) => entry.section === view)?.section ?? VIEW_ALIASES.get(view) ?? "overview";
}

export function analyticsDestinationAliases(section: AnalyticsDestinationSection): ReadonlyArray<string> {
  return [...VIEW_ALIASES].filter(([, target]) => target === section).map(([alias]) => alias);
}

export function analyticsDestinationPermissions(section: AnalyticsDestinationSection): ReadonlyArray<string> {
  return ANALYTICS_DESTINATIONS.find((entry) => entry.section === section)?.permissions ?? [];
}

export function analyticsDestinationHref(section: string) {
  return `/admin/analytics?view=${section}`;
}

export function analyticsWorkspaceHref(query: string, section: string) {
  const params = new URLSearchParams(query);
  for (const key of ["tab", "section", "campaign", "account", "channel", "from"]) params.delete(key);
  params.set("view", section);
  return `/admin/analytics?${params.toString()}`;
}
